import { RouterProvider } from "react-router-dom"
import { createRoot } from "react-dom/client"
import { router } from "./pages"
import { AuthContextProvider } from "./context/AuthContext"
import { LanguageProvider } from "./context/LanguageContext"

// Importing the Bootstrap 5 CSS
import "bootstrap/dist/css/bootstrap.min.css"

createRoot(document.getElementById("root")).render(
  <LanguageProvider>
    <AuthContextProvider>
      <RouterProvider router={router} />
    </AuthContextProvider>
  </LanguageProvider>,
)
